import { render, staticRenderFns } from "./privacy.vue?vue&type=template&id=4994f8c1&scoped=true&lang=pug&"
var script = {}
import style0 from "./privacy.vue?vue&type=style&index=0&id=4994f8c1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4994f8c1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4994f8c1')) {
      api.createRecord('4994f8c1', component.options)
    } else {
      api.reload('4994f8c1', component.options)
    }
    module.hot.accept("./privacy.vue?vue&type=template&id=4994f8c1&scoped=true&lang=pug&", function () {
      api.rerender('4994f8c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/info/privacy.vue"
export default component.exports